import useApi from 'assets/hooks/api/useApi';
import usePageRouter from 'assets/hooks/pageRouter/usePageRouter';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { useDataProviderPartition } from 'assets/providers/data/DataProvider';
import { documentTranslationListApi } from 'models/localization/documentTranslation/Model.DocumentTranslation';
import ProductTransferOwnershipDocument from 'models/productManagement/productTransferOwnershipDocument/Model.ProductTransferOwnershipDocument';
import { productTransferOwnershipDocumentIndexRoute } from './ProductTransferOwnershipDocument.Index';

export default function useProductTransferOwnershipDocument() {
  const { permissions } = useAuthStore();
  const pageRouter = usePageRouter<
    Module.ProductManagement.ProductTransferOwnershipDocument.Params,
    Module.ProductManagement.ProductTransferOwnershipDocument.Query
  >({
    route: productTransferOwnershipDocumentIndexRoute,
  });
  const productTransferOwnershipDocumentId = pageRouter.params.id ? parseInt(pageRouter.params.id) : null;

  const { payload: productTransferOwnershipDocument, isExecuting: isLoadingProductTransferOwnershipDocument } = useApi(
    {
      action: ProductTransferOwnershipDocument.find,
      body: { documentId: productTransferOwnershipDocumentId },
      default: null,
      wait: !productTransferOwnershipDocumentId,
    },
    [productTransferOwnershipDocumentId]
  );

  const listDocumentTranslationsApi = useApi(
    {
      action: documentTranslationListApi,
      body: { documentType: 'ProductTransferOwnershipDocument', documentId: [productTransferOwnershipDocumentId] },
      wait: !productTransferOwnershipDocumentId,
    },
    [productTransferOwnershipDocumentId]
  );
  function reloadTranslatedDocs() {
    listDocumentTranslationsApi.execute((b) => b);
  }

  const canView = permissions.EDIT_PRODUCT;

  return {
    canView,
    pageRouter,
    productTransferOwnershipDocument,
    isLoadingProductTransferOwnershipDocument,
    permissions,
    translatedDocumentList: listDocumentTranslationsApi?.payload?.data ?? [],
    reloadTranslatedDocs,
  };
}

export function useProductTransferOwnershipDocumentProvider() {
  return useDataProviderPartition<ReturnType<typeof useProductTransferOwnershipDocument>>(
    'ProductTransferOwnershipDocumentHook'
  );
}
